/**
 * 单元格内部内容 展示为url类型
 *
 */
import React from 'react';
import BubbleEllipsis from "@/pages/datalab/components/BubbleEllipsis";
import { ensureValidUrl } from "@/pages/datalab/utils/utils";
import { IAliTableCellComponentProps } from "@customComp/AliTableAnalytics/types";

const UrlCell = ({text}: IAliTableCellComponentProps) => (<BubbleEllipsis
  content={text}
  ellipsisContent={(<a href={ensureValidUrl(text)} target="_blank" rel="noreferrer">{text}</a>)}
  ellipsisClassName={'dbl-table-url-cell'}
/>);

export default UrlCell;